/* Fetch the 3D engine only when a sculpture is approached — and, before it is here, show the still this browser kept
   of the piece on an earlier visit (model-viewer.js keeps the first frame it draws, on the black; the same key), so a
   piece seen before is there at once, never Shopify's own poster of it, which is drawn on white. */
(() => {
  const source = document.currentScript?.dataset.modelSrc;
  if (!source || customElements.get('gg-model-viewer')) return;
  const placeStill = (v) => {
    if (v.querySelector(':scope > .gg-model-viewer__still')) return;
    let url = null;
    try { url = localStorage.getItem('gg-model-still:cream-v1:' + ['src', 'yaw', 'pitch', 'roll', 'flip', 'tilt', 'metal', 'display', 'line-color', 'line-opacity', 'scale', 'offset-x', 'offset-y'].map((k) => v.getAttribute(k) || '').join('|')); } catch { return; }
    if (!url) return;
    const img = document.createElement('img'); img.className = 'gg-model-viewer__still'; img.alt = ''; img.setAttribute('aria-hidden', 'true'); img.draggable = false; img.src = url;
    v.prepend(img);
  };
  let queued = false;
  const load = () => {
    if (queued) return;
    queued = true;
    observer?.disconnect();
    additions?.disconnect();
    const script = document.createElement('script');
    script.src = source; script.async = true;
    document.body.append(script);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    if (entries.some(e => e.isIntersecting)) load();
  }, { rootMargin: '300px' }) : null;
  const watch = root => {
    if (root.matches?.('gg-model-viewer')) { placeStill(root); observer?.observe(root); }
    root.querySelectorAll?.('gg-model-viewer').forEach(n => { placeStill(n); observer?.observe(n); });
  };
  const additions = observer ? new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) watch(node);
  }) : null;
  if (observer) { watch(document); additions.observe(document.body, {childList:true,subtree:true}); }
  else { document.querySelectorAll('gg-model-viewer').forEach(placeStill); load(); }
})();

